import React, { useState } from "react";
import { Plus, Check, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function AddToListDialog({ open, onOpenChange, placeId }) {
  const { t, lists, createList, toggleInList } = useApp();
  const [newName, setNewName] = useState("");

  const handleCreate = () => {
    const name = newName.trim();
    if (!name) return;
    const id = createList(name);
    toggleInList(id, placeId);
    setNewName("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="add-to-list-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{t("add_to_list")}</DialogTitle>
          <DialogDescription className="sr-only">{t("add_to_list")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {lists.length === 0 && <p className="text-sm text-ink-muted">{t("my_lists")}…</p>}
          {lists.map((l) => {
            const inList = l.placeIds.includes(placeId);
            return (
              <button
                key={l.id}
                data-testid={`list-option-${l.id}`}
                onClick={() => toggleInList(l.id, placeId)}
                className={`w-full flex items-center justify-between rounded-xl border px-3.5 py-3 text-left text-sm font-medium transition-colors ${
                  inList ? "border-terracotta bg-terracotta-light text-terracotta" : "border-border hover:bg-sand"
                }`}
              >
                <span>{l.name}</span>
                {inList && <Check className="h-4 w-4" />}
              </button>
            );
          })}
        </div>
        <div className="flex items-center gap-2 pt-1">
          <input
            data-testid="new-list-input"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleCreate()}
            placeholder={t("list_name")}
            className="flex-1 rounded-xl border border-border bg-white px-3.5 py-2.5 text-sm outline-none focus:border-terracotta"
          />
          <button
            data-testid="create-list-btn"
            onClick={handleCreate}
            className="grid h-10 w-10 place-items-center rounded-xl bg-terracotta text-white hover:bg-terracotta-hover"
          >
            <Plus className="h-5 w-5" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
